import { render, staticRenderFns } from "./goodsDetailsTpl0.vue?vue&type=template&id=3b818aee&scoped=true"
import script from "./goodsDetailsTpl0.vue?vue&type=script&lang=js"
export * from "./goodsDetailsTpl0.vue?vue&type=script&lang=js"
import style0 from "./goodsDetailsTpl0.vue?vue&type=style&index=0&id=3b818aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b818aee",
  null
  
)

export default component.exports